import React from 'react';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './public_page.module.css';

type PublicPageStyles = {
  background: string;
  container: string;
  centeredBackground: string;
  centeredContainer: string;
};

const themedStyles: ThemedStyles<PublicPageStyles> = {
  [Theme.DAYLIGHT]: {
    background: baseStyles.daylightBackground,
    container: baseStyles.container,
    centeredBackground: baseStyles.daylightCenteredBackground,
    centeredContainer: baseStyles.centeredContainer,
  },
  [Theme.MIDNIGHT]: {
    background: baseStyles.midnightBackground,
    container: baseStyles.container,
    centeredBackground: baseStyles.midnightCenteredBackground,
    centeredContainer: baseStyles.centeredContainer,
  },
};

export type PublicPageProps = {
  children: React.ReactNode;
};

export const PublicPage = React.memo(({ children }: PublicPageProps) => {
  const styles = useStyles(themedStyles);
  return (
    <div className={styles.background}>
      <div className={styles.container}>
        {children}
      </div>
    </div>
  );
});
PublicPage.displayName = 'PublicPage';


export const CenteredPublicPage = React.memo(({ children }: PublicPageProps) => {
  const styles = useStyles(themedStyles);
  return (
    <div className={styles.centeredBackground}>
      <div className={styles.centeredContainer}>
        {children}
      </div>
    </div>
  );
});
CenteredPublicPage.displayName = 'CenteredPublicPage';
